export default __webpack_public_path__ + "static/media/book.f12c14a4.png";